import React from 'react'
import PropTypes from 'prop-types'

const LowerCaseIcon = ({size = 16}) => {
  return (
    <svg width={size} height={size} fill="none">
      <path
        fill="#000"
        d="M10.45 11.106c0 .206.024.353.07.44.056.089.159.133.308.133h.168c.065 0 .14-.01.224-.03v1.16c-.056.02-.13.04-.224.059a2.14 2.14 0 0 1-.266.073 2.766 2.766 0 0 1-.517.059c-.327 0-.597-.069-.812-.206-.215-.136-.354-.376-.42-.719a2.789 2.789 0 0 1-1.175.705c-.457.147-.9.22-1.33.22-.326 0-.638-.049-.937-.147a2.47 2.47 0 0 1-.797-.396 2.164 2.164 0 0 1-.546-.69A2.33 2.33 0 0 1 4 10.784c0-.47.08-.852.238-1.145.168-.294.382-.524.644-.69.27-.167.569-.284.895-.353a9.05 9.05 0 0 1 1.007-.176c.29-.059.565-.098.826-.117.261-.03.49-.074.686-.132.205-.06.363-.147.475-.265.122-.127.182-.313.182-.557A.858.858 0 0 0 8.8 6.82a.873.873 0 0 0-.363-.308 1.243 1.243 0 0 0-.476-.147 3.088 3.088 0 0 0-.504-.044c-.448 0-.816.098-1.105.294-.29.195-.453.499-.49.91H4.266c.028-.49.14-.896.336-1.219.196-.323.443-.582.741-.778a3.051 3.051 0 0 1 1.036-.41A5.846 5.846 0 0 1 7.554 5c.354 0 .704.04 1.05.117.345.079.652.206.923.382.28.176.504.406.672.69.168.274.251.612.251 1.013v3.904ZM8.855 8.993c-.242.166-.54.269-.895.308-.355.03-.71.078-1.064.147-.168.03-.33.073-.49.132a1.246 1.246 0 0 0-.42.22.943.943 0 0 0-.293.367 1.335 1.335 0 0 0-.098.543c0 .186.051.343.154.47.103.127.224.23.364.308.15.069.308.117.476.147.177.03.335.044.475.044.178 0 .369-.025.574-.074.205-.048.396-.132.574-.249.186-.117.34-.264.461-.44.122-.186.182-.411.182-.676V8.993Z"
      />
    </svg>
  )
}

LowerCaseIcon.propTypes = {
  size: PropTypes.number,
}

export default LowerCaseIcon
